/* eslint-disable sonarjs/no-duplicate-string */
import { ModalEntry } from '@superbet-group/web.lib.vue-utilities';

import ModalHeader from '@app/modals/ModalHeader.vue';
import ErrorModal from '@app/modals/modals/ErrorModal.vue';
import { withLoadingSpinner } from '@app/utils/withLoadingSpiner';

import { SecurityCheckModalsGroup } from '@accountFederation/modules/securityCheck/faceId/mfaFlows';
import modalCodes from './modalCodes';

const modals: ModalEntry[] = [
    {
        code: modalCodes.error,
        title: 'error',
        component: ErrorModal,
        isIndependent: true,
    },
    {
        isIndependent: true,
        code: modalCodes.login,
        component: withLoadingSpinner(() => import('@app/modals/modals/auth/LoginModal.vue')),
        transition: {
            name: 'fade',
        },
        group: 'login',
    },
    {
        code: modalCodes.forgotPassword,
        title: 'forgot password',
        containerClass: 'modal--native-design',
        // TODO: SdsModal, deprecated?
        component: withLoadingSpinner(() => import('@accountFederation/modals/resetPassword/ForgotPasswordModal.vue')),
        header: {
            component: ModalHeader,
            isTextTitle: true,
        },
    },
    {
        code: modalCodes.sdsForgotPassword,
        component: withLoadingSpinner(() => import('@accountFederation/modals/resetPassword/SdsForgotPasswordModal.vue')),
        isIndependent: true,
    },
    {
        code: modalCodes.accountLocked,
        title: 'account locked',
        containerClass: 'modal--native-design modal-title-md',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modules/accountRecovery/modals/AccountLockedContainerModal.vue')),
        header: {
            component: ModalHeader,
            isTextTitle: true,
        },
    },
    {
        code: modalCodes.accountLockNotice,
        containerClass: 'modal--native-design modal-title-center modal-title-md',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modules/accountRecovery/modals/AccountLockNoticeModal.vue')),
    },
    {
        code: modalCodes.resetPassword,
        title: 'password reset',
        containerClass: 'modal--native-design',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modals/resetPassword/ResetPasswordContainerModal.vue')),
        header: {
            component: ModalHeader,
            isTextTitle: true,
        },
    },
    {
        code: modalCodes.paymentIntro,
        title: 'withdrawal requirements',
        containerClass: 'withdrawal_intro',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modals/userProfile/PaymentIntroModal.vue')),
    },
    {
        code: modalCodes.idCardVerificationIntro,
        title: 'identity document verification',
        containerClass: 'card-verification-intro_modal',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/idCardVerification/IdCardVerificationIntroModal.vue')),
    },
    {
        code: modalCodes.idCardVerificationIntroGetId,
        title: 'identity document verification',
        containerClass: 'card-verification-intro_modal modal--native-design',
        // TODO: SdsModal
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/idCardVerification/IdCardVerificationIntroModalGetId.vue')),
    },
    {
        code: modalCodes.idCardVerificationReKyc,
        title: 'identity document verification',
        containerClass: 'card-verification-intro_modal modal--native-design',
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/idCardVerification/IdCardVerificationReKycModal.vue')),
    },
    {
        code: modalCodes.idCardVerification,
        title: 'identity document verification',
        containerClass: 'card-verification_modal modal--native-design',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/idCardVerification/IdCardVerificationModal.vue')),
        header: {
            component: ModalHeader,
            isTextTitle: true,
        },
    },
    {
        code: modalCodes.idCardVerificationApproved,
        containerClass: 'card-verification_confirm_modal',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/idCardVerification/IdCardVerificationApprovedModal.vue')),
    },
    {
        code: modalCodes.idCardVerificationApprovedGetId,
        title: 'pam.kyc.status.youAreVerified',
        containerClass: 'modal--native-design',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/idCardVerification/IdCardVerificationApprovedGetIdModal.vue')),
        header: {
            component: ModalHeader,
            isTextTitle: true,
        },
    },
    {
        code: modalCodes.idCardVerificationPendingStatus,
        title: 'identity verification',
        containerClass: 'card-verification_modal',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/idCardVerification/IdCardVerificationPendingStatusModal.vue')),
    },
    {
        code: modalCodes.multiStepIdCardVerificationAddress,
        title: 'identity verification',
        containerClass: 'card-verification_modal',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@src/app/modals/modals/userProfile/idCardVerification/MultiStepIdCardVerificationAddressModal.vue')),
    },
    {
        code: modalCodes.multiStepIdVerification,
        title: 'identity document verification',
        containerClass: 'card-verification_modal',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/idCardVerification/MultiStepIdVerificationModal.vue')),
    },
    {
        code: modalCodes.multiStepIdVerificationCamera,
        title: 'identity document verification',
        containerClass: 'card-verification_modal card-verification_modal-camera',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/idCardVerification/MultiStepIdVerificationModalCamera.vue')),
    },
    {
        code: modalCodes.multiStepIdVerificationUpload,
        title: 'identity document verification',
        containerClass: 'card-verification_modal card-verification_modal-upload',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/idCardVerification/MultiStepIdVerificationModalUpload.vue')),
    },
    {
        code: modalCodes.multiStepIdVerificationCollectData,
        title: 'pam.idCardVerification.title',
        component: withLoadingSpinner(() => import('@accountFederation/modules/idCardVerification/modals/MultiStepIdVerificationCollectDataModal.vue')),
        isIndependent: true,
    },
    {
        code: modalCodes.getIdVerification,
        title: 'pam.getIdVerification.title',
        containerClass: 'card-verification_modal card-verification_modal-document-data modal--native-design',
        header: {
            component: ModalHeader,
            isTextTitle: true,
        },
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modules/idCardVerification/VerificationContainer.vue')),
    },
    {
        code: modalCodes.getIdVerificationPending,
        component: withLoadingSpinner(() => import('@accountFederation/modules/idCardVerification/modals/getIdVerificationPendingModal.vue')),
        isIndependent: true,
    },
    {
        code: modalCodes.exitKyc,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/idCardVerification/modals/ExitKycModal.vue')),
    },
    {
        code: modalCodes.exitRegister,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/idCardVerification/modals/exitRegisterModal.vue')),
    },
    {
        code: modalCodes.exitKycVerificationCaptive,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/idCardVerification/modals/idCardVerificationCaptive/ExitKycVerificationCaptiveModal.vue')),
        isUnique: true,
    },
    {
        code: modalCodes.verificationKycSuccessful,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/idCardVerification/modals/idCardVerificationCaptive/VerificationKycSuccessfulModal.vue')),
    },
    {
        code: modalCodes.securityCheckIntro,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/securityCheck/faceId/modals/SecurityCheckIntroModal.vue')),
        group: SecurityCheckModalsGroup,
    },
    {
        code: modalCodes.securityCheckError,
        component: withLoadingSpinner(() => import('@accountFederation/modules/securityCheck/faceId/modals/SecurityCheckErrorModal.vue')),
        isIndependent: true,
        group: SecurityCheckModalsGroup,
    },
    {
        code: modalCodes.securityCheckSuccess,
        component: withLoadingSpinner(() => import('@accountFederation/modules/securityCheck/faceId/modals/SecurityCheckSuccessModal.vue')),
        isIndependent: true,
        group: SecurityCheckModalsGroup,
    },
    {
        code: modalCodes.transactionHistory,
        containerClass: 'history_modal',
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/HistoryModal.vue')),
    },
    {
        code: modalCodes.allTransactionHistory,
        containerClass: 'all_transactions_modal',
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/HistoryModal.vue')),
    },
    {
        code: modalCodes.mobileBetSlip,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@betslipFederation/MobileBetSlip.vue')),
    },
    {
        code: modalCodes.welcomeBonusIntro,
        title: 'welcome bonus',
        isIndependent: true,
        containerClass: 'welcome_bonus_modal',
        component: withLoadingSpinner(() => import('@app/modals/modals/welcomeBonus/WelcomeBonusIntroModal.vue')),
    },
    {
        code: modalCodes.welcomeBonus,
        title: 'welcome bonus',
        isIndependent: true,
        containerClass: 'welcome_bonus_modal',
        component: withLoadingSpinner(() => import('@app/modals/modals/welcomeBonus/WelcomeBonusModal.vue')),
    },
    {
        code: modalCodes.loyaltyShopBonus,
        isIndependent: true,
        containerClass: 'loyalty_shop_bonus_modal',
        component: withLoadingSpinner(() => import('@app/modals/modals/loyalty/shop/ShopBonusModal.vue')),
    },
    {
        code: modalCodes.message,
        isIndependent: true,
        containerClass: 'message_modal',
        component: withLoadingSpinner(() => import('@app/modals/modals/messages/MessageModal.vue')),
    },
    {
        code: modalCodes.newSmsValidation,
        isIndependent: true,
        containerClass: 'sms_validation_modal modal-title-center modal-title-text-align-center',
        component: withLoadingSpinner(() => import('@accountFederation/modules/smsValidation/NewSmsValidationContainer.vue')),
    },
    {
        code: modalCodes.sdsSmsValidation,
        isIndependent: true,
        containerClass: 'sms_validation_modal modal-title-center modal-title-text-align-center',
        component: withLoadingSpinner(() => import('@accountFederation/modules/smsValidation/SdsSmsValidationContainer.vue')),
    },
    {
        code: modalCodes.chooseGdpr,
        title: 'Choose GDPR',
        containerClass: 'gdpr_modal',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/ChooseGdprModal.vue')),
    },
    {
        code: modalCodes.termsUpdate,
        title: 'Terms update',
        isIndependent: true,
        containerClass: 'terms_update_modal',
        component: withLoadingSpinner(() => import('@accountFederation/modals/userProfile/TermsUpdateModal.vue')),
    },
    {
        code: modalCodes.sessionDuration,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/notifications/SessionDurationModal.vue')),
    },
    {
        code: modalCodes.ticketSubmitRetry,
        title: 'submit failed',
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/ticketSubmitRetry/TicketSubmitRetryModal.vue')),
    },
    {
        code: modalCodes.mobileStatusCode,
        isIndependent: true,
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modals/userProfile/MobileStatusCodeModal.vue')),
    },
    {
        code: modalCodes.statusCode,
        containerClass: 'status-code-modal modal-title-lg modal-title-center',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modals/userProfile/StatusCodeModal.vue')),
    },
    {
        code: modalCodes.underAge,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/UnderAgeModal.vue')),
    },
    {
        code: modalCodes.bingoBashMessageModal,
        title: 'bingo bash',
        containerClass: 'bingo-bash-message-modal',
        component: withLoadingSpinner(() => import('@app/modals/modals/bingoBash/BingoBashMessageModal.vue')),
    },
    {
        code: modalCodes.superSpinMessageModal,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/superSpin/SuperSpinMessageModal.vue')),
    },
    {
        code: modalCodes.superBonusModal,
        title: 'super bonus',
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/superBonus/SuperBonusModal.vue')),
    },
    {
        code: modalCodes.printableHistoryDetail,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/PrintableHistoryDetailModal.vue')),
    },
    {
        code: modalCodes.bonusCampaignModal,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/bonus/BonusCampaignModal.vue')),
    },
    {
        code: modalCodes.eligibleForCampaignModal,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/bonus/EligibleForCampaignModal.vue')),
    },

    {
        code: modalCodes.bonusStatusModal,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/bonus/BonusStatusModal.vue')),
    },
    {
        code: modalCodes.bonusAbuserModal,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/bonus/BonusAbuserModal.vue')),
    },
    {
        code: modalCodes.accountReopening,
        title: 'pam.login.accountReopen.title',
        containerClass: 'modal--native-design modal-title-center',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modals/accountReopen/AccountReopenModal.vue')),
        header: {
            component: ModalHeader,
            isTextTitle: true,
            isHelpDisplayed: false,
        },
    },
    {
        code: modalCodes.accountReopeningAgreement,
        title: 'pam.login.accountReopenAgreement.title',
        containerClass: 'modal--native-design',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modals/accountReopen/ReopenAgreementModal.vue')),
        header: {
            component: ModalHeader,
            isTextTitle: true,
            isHelpDisplayed: false,
        },
    },
    {
        code: modalCodes.sdsAccountReopening,
        component: withLoadingSpinner(() => import('@accountFederation/modals/accountReopen/SdsAccountReopenModal.vue')),
        isIndependent: true,
    },
    {
        code: modalCodes.completeRegistration,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modals/CompleteRegistrationModal.vue')),
    },
    {
        code: modalCodes.completeAccountActivation,
        title: 'pam.notifications.completeRegistration',
        containerClass: 'modal--native-design modal--account-activation modal-title-lg',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modals/notifications/CompleteAccountActivationModal.vue')),
        header: {
            component: ModalHeader,
            isTextTitle: true,
            isHelpDisplayed: false,
        },
    },
    {
        code: modalCodes.activationLinkExpired,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modules/authentication/components/ActivationLinkExpiredModal.vue')),
    },
    {
        code: modalCodes.limitInformation,
        title: 'responsible gaming limits',
        containerClass: 'limit-information_modal',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modals/responsibleGaming/LimitInformationModal.vue')),
    },
    {
        code: modalCodes.idTypeModalPicker,
        title: '',
        containerClass: 'second-step-upload_modal',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@app/modals/modals/IdTypeModalPicker.vue')),
    },
    {
        code: modalCodes.responsibleGamblingModal,
        title: '',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@app/modals/modals/userProfile/RGModal.vue')),
    },
    {
        code: modalCodes.realityCheck,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modals/notifications/RealityCheckModal.vue')),
        transition: {
            name: 'fade',
        },
        isUnique: true,
    },
    {
        code: modalCodes.logoutDelay,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/logoutDelay/LogoutDelayModal.vue')),
    },
    {
        code: modalCodes.betBuilderConflict,
        isIndependent: true,
        containerClass: 'bet-builder_modal',
        component: withLoadingSpinner(() => import('@sportOfferFederation/bet-builder/modals/BetBuilderConflictModal.vue')),
    },
    {
        code: modalCodes.betBuilderOnboarding,
        isIndependent: true,
        containerClass: 'bet-builder_modal',
        component: withLoadingSpinner(() => import('@sportOfferFederation/bet-builder/modals/BetBuilderOnboardingModal.vue')),
    },
    {
        code: modalCodes.boostedOddConflict,
        isIndependent: true,
        containerClass: 'boosted-odd-conflict_modal',
        component: withLoadingSpinner(() => import('@sportOfferFederation/boostedOdds/modals/BoostedOddConflictModal.vue')),
    },
    {
        code: modalCodes.lastLogin,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modals/notifications/LastLoginModal.vue')),
        transition: {
            name: 'fade',
        },
    },
    {
        code: modalCodes.welcomeOffer,
        containerClass: 'welcome-offer_modal modal--native-design',
        component: withLoadingSpinner(() => import('@app/modals/modals/welcomeBonus/WelcomeOfferModal.vue')),
        transition: {
            name: 'fade',
        },
    },
    {
        code: modalCodes.welcomeOfferError,
        containerClass: 'modal--native-design',
        component: withLoadingSpinner(() => import('@app/modals/modals/welcomeBonus/WelcomeOfferErrorModal.vue')),
        isIndependent: true,
        transition: {
            name: 'fade',
        },
    },
    {
        code: modalCodes.responsibleGamblingInfo,
        containerClass: 'modal--native-design responsible-gambling',
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modals/responsibleGaming/ResponsibleGamblingInfoModal.vue')),
    },
    {
        code: modalCodes.licencePreferences,
        containerClass: 'modal--native-design licence-preferences_modal modal-title-lg modal-title-center',
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modals/LicencePreferencesModal.vue')),
    },
    {
        code: modalCodes.licenseRequired,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/LicenseRequiredModal.vue')),
    },
    {
        code: modalCodes.usernameUpdate,
        component: withLoadingSpinner(() => import('@accountFederation/modals/userProfile/UsernameUpdate.vue')),
        isIndependent: true,
    },
    {
        code: modalCodes.successModal,
        containerClass: 'modal--native-design success-modal modal-title-md modal-title-center',
        title: 'pam.successModal.title',
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modals/successModal.vue')),
    },
    {
        code: modalCodes.limitReached,
        containerClass: 'modal--native-design',
        title: 'pam.deposit.modal.limits.title',
        header: {
            component: ModalHeader,
            isTextTitle: true,
        },
        // TODO: SdsModal
        component: withLoadingSpinner(() => import('@accountFederation/modals/responsibleGaming/LimitReachedModal.vue')),
    },
    {
        code: modalCodes.tooltipInfo,
        containerClass: 'tooltip-info-modal',
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/TooltipInfoModal.vue')),
    },
    {
        code: modalCodes.cashBonus,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/bonus/CashBonusModal.vue')),
    },
    {
        code: modalCodes.rgCloseAccount,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/responsibleGaming/components/canon/modals/CloseAccountModal.vue')),
    },
    {
        code: modalCodes.rgSelfExclusion,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/responsibleGaming/components/canon/modals/SelfExclusionModal.vue')),
    },
    {
        code: modalCodes.rgTimeOut,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/responsibleGaming/components/canon/modals/TimeOutModal.vue')),
    },
    {
        code: modalCodes.rgSetLimit,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/responsibleGaming/components/canon/modals/ChangeLimitModal.vue')),
    },
    {
        code: modalCodes.rgConfirmLimits,
        isIndependent: true,
        group: 'confirmLimits',
        component: withLoadingSpinner(() => import('@accountFederation/modules/responsibleGaming/components/canon/modals/ConfirmLimitChangeModal.vue')),
    },
    {
        code: modalCodes.rgRemoveLimits,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/responsibleGaming/components/canon/modals/RemoveLimitsModal.vue')),
    },
    {
        code: modalCodes.rgRealityCheckConfirmation,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/responsibleGaming/components/canon/modals/RealityCheckModal.vue')),
    },
    {
        code: modalCodes.rgCancelLimit,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/responsibleGaming/components/canon/modals/CancelPendingLimitModal.vue')),
    },
    {
        code: modalCodes.marketLineDescription,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modules/eventGrid/components/markets/marketHeader/modal/MarketLineDescriptionModal.vue')),
    },
    {
        code: modalCodes.superAdvantageDescription,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modules/sportOffer/sharedSubmodules/SuperAdvantageModal.vue')),
    },
    {
        code: modalCodes.geoLocationCheck,
        isIndependent: true,
        transition: {
            name: 'fade',
        },
        component: withLoadingSpinner(() => import('@app/modals/modals/GeoLocationCheckModal.vue')),
    },
    {
        code: modalCodes.licenceMigration,
        isIndependent: true,
        isClosable: false,
        component: withLoadingSpinner(() => import('@accountFederation/modules/licencePreferences/LicenceMigrationModal.vue')),
    },
    {
        code: modalCodes.migrationSuccess,
        isIndependent: true,
        isClosable: false,
        component: withLoadingSpinner(() => import('@accountFederation/modules/licencePreferences/MigrationSuccessModal.vue')),
    },
    {
        code: modalCodes.migrationUnderage,
        isIndependent: true,
        isClosable: false,
        component: withLoadingSpinner(() => import('@accountFederation/modules/licencePreferences/UnderageModal.vue')),
    },
    {
        code: modalCodes.setFeatureBranch,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/featureTest/FeatureTestModal.vue')),
    },
    {
        code: modalCodes.pushNotification,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/notifications/PushNotificationModal.vue')),
    },
    {
        code: modalCodes.mfaCode,
        isClosable: false,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modals/MfaCodeModal.vue')),
    },
    {
        code: modalCodes.smsVerify,
        isIndependent: true,
        isClosable: false,
        component: withLoadingSpinner(() => import('@accountFederation/modals/userProfile/smsVerifyModal/SdsSmsVerifyModal.vue')),
    },
    {
        code: modalCodes.annualDataValidationModal,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/idCardVerification/modals/AnnualDataValidationModal.vue')),
    },
    {
        code: modalCodes.personalDataValidationModal,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/idCardVerification/modals/PersonalDataValidationModal.vue')),
    },
    {
        code: modalCodes.closeAccountMfa,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/responsibleGaming/components/canon/modals/CloseAccountSecurityModal.vue')),
    },
    {
        code: modalCodes.reactivationMailOtp,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/securityCheck/modals/ReactivationMailOtpModal.vue')),
        group: SecurityCheckModalsGroup,
    },
    {
        code: modalCodes.otpLogin,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/securityCheck/modals/OtpLoginModal.vue')),
        group: SecurityCheckModalsGroup,
    },
    {
        code: modalCodes.mfaPreferenceOtp,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/securityCheck/modals/MfaPreferenceOtpModal.vue')),
        group: SecurityCheckModalsGroup,
    },
    {
        code: modalCodes.disableMfaPreference,
        isClosable: false,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/securityCheck/modals/DisableMfaPreferenceModal.vue')),
        group: SecurityCheckModalsGroup,
    },
    {
        code: modalCodes.mfaPreferenceStatus,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/securityCheck/modals/MfaPreferenceStatusModal.vue')),
        group: SecurityCheckModalsGroup,
    },
    {
        code: modalCodes.SuperBonusV2WelcomeModal,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/super-bonus/SuperBonusV2WelcomeModal.vue')),
    },
    {
        code: modalCodes.captiveKycRequired,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/idCardVerification/modals/idCardVerificationCaptive/CaptiveKycVerificationRequiredModal.vue')),
    },
    {
        code: modalCodes.captiveKycPending,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modules/idCardVerification/modals/idCardVerificationCaptive/CaptiveKycVerificationPendingModal.vue')),
    },
    {
        code: modalCodes.superBonusV2Modal,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modals/modals/superBonus/SuperBonusV2Modal.vue')),
    },
    {
        code: modalCodes.brazilMigrationTerms,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@accountFederation/modals/brazilMigration/BrazilMigrationTermsModal.vue')),
        isClosable: false,
    },
    {
        code: modalCodes.sportSelectDrawer,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@sportOfferFederation/modals/SportSelectDrawer.vue')),
    },
    {
        containerClass: 'modal--native-design modal-title-center modal-title-md',
        isIndependent: true,
        title: '',
        code: modalCodes.surveyModalCode,
        component: withLoadingSpinner(() => import('@accountFederation/modals/survey/SurveyModal.vue')),
    },
    {
        code: modalCodes.insuranceSubstitutionModal,
        isIndependent: true,
        component: withLoadingSpinner(() => import('@app/modules/sportOffer/sharedSubmodules/InsuranceSubstitutionModal.vue')),
    },
];

export default modals;
